import { Post, Get } from "../utils/http-utils";

export const openTunnel = async (queryParams) => {
    return Post("/tunnel/open", queryParams)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            throw err;
        });
};

export const closeTunnel = async (queryParams) => {
    return Post("/tunnel/close", queryParams)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            throw err;
        });
};

export const getActiveSessions = async (thingName) => {
    return Get(`/tunnel/list?thingName=${thingName}`)
        .then((data) => {
            if (Array.isArray(data)) {
                return data;
            }
            if (data && Array.isArray(data.data)) {
                return data.data;
            }
            if (data && Array.isArray(data.sessions)) {
                return data.sessions;
            }
            return [];
        })
        .catch((err) => {
            console.error('Error fetching active sessions:', err);
            return [];
        });
};
